import React from 'react';
import { Modal, Spinner, Button } from 'react-bootstrap';
import { cancelTransaction } from '../services/transactionService';
import '../stylesheets/APIProgress.css';

class APIProgress extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }
    handleCancel = () => cancelTransaction(this.props.terminalID);
    render() {
        return (
            <Modal show={this.props.show} backdrop="static" centered animation={false}>
                <Modal.Body>
                    <div className="spinner-alignment">{this.props.progressText} <Spinner className="spinner-size" animation="border" variant="primary" /></div>
                    <div className="spinner-alignment"><Button variant="danger" onClick={() => this.handleCancel()}>Cancel</Button></div>
                </Modal.Body>
            </Modal>
        );
    }
}
export default APIProgress;